import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResultsComponent } from './results.component';
import { ConfigService } from '../shared/config.service';
import { CaseResultComponent } from './case-result/case-result.component';
import { CollectAnswerComponent } from './collect-answer/collect-answer.component';
import { CollectResponseComponent } from './collect-response/collect-response.component';

const routes: Routes = [
  {
    path: 'result',
    component: CaseResultComponent,
    resolve: { config: ConfigService }
  },
  {
    path: 'collect',
    component: CollectAnswerComponent
  },
  {
    path: 'response',
    component: CollectResponseComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResultsRoutingModule { }
